import React from "react";
import classNames from "classnames";
import "./MainHeader.css";

const isImage = src => src.indexOf(/\.[A-Za-z]{1-4}$/) >= 0;

class MainHeader extends React.Component {
  render() {
    const { children, cover } = this.props;

    const classes = classNames("main-header", this.props.className, {
      "no-cover": !cover
    });

    const getStyle = () => {
      if (cover) {
        if (isImage(cover)) {
          return {
            backgroundImage: `url("${cover}")`
          };
        }
        return {
          backgroundColor: cover,
        };
      }
      return null;
    };

    return (
      <header className={classes} style={getStyle()}>
        {children}
      </header>
    );
  }
}

export default MainHeader;



// WEBPACK FOOTER //
// ./src/layouts/MainHeader/MainHeader.jsx